import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Register = () => {
  const [user, setUser] = useState({ email: "", password: "", role: "user" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/api/register", user, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
      navigate("/");
    } catch (error) {
      console.error("Registration failed", error);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Реєстрація</h2>
      <form >
        <div className="mb-3">
          <label>Email:</label>
          <input type="email" name="email" className="form-control" onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Пароль:</label>
          <input type="password" name="password" className="form-control" onChange={handleChange} required />
        </div>
        
        <button type="submit" className="btn btn-primary">Зареєструватися</button>
      </form>
    </div>
  );
};

export default Register;
